module.exports = "/info/img/logo2.png";